import React from 'react';
import EnhancedTableBase from '../../../components/common/EnhancedTable/EnhancedTableBase';
import { EnhancedTableProps } from '../../../components/common/EnhancedTable/types';
import './EnhancedProjects.css';

/**
 * EnhancedProjectsTable component
 * 
 * This component extends the EnhancedTableBase component with specific styling and behavior
 * for the Projects page.
 */
function EnhancedProjectsTable<T extends Record<string, any>>(props: EnhancedTableProps<T>) {
  return (
    <EnhancedTableBase
      {...props}
      className={`${props.className || ''}`}
      defaultSort={props.defaultSort}
      onSort={props.onSort}
    />
  );
}

export default EnhancedProjectsTable;
